// extracted by mini-css-extract-plugin
module.exports = {"cgcDropdownChildren":"AddCGCToUnitsModal_cgcDropdownChildren__1NZr-"};